import { useReducer } from 'react';
import { createActions, collectionReducer } from './utils.js';
export function useCollectionState(options, collectionRef) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var _k = useReducer(collectionReducer, {
        selectedItems: (_b = (_a = options.selection) === null || _a === void 0 ? void 0 : _a.defaultSelectedItems) !== null && _b !== void 0 ? _b : [],
        sortingState: (_c = options.sorting) === null || _c === void 0 ? void 0 : _c.defaultState,
        currentPageIndex: (_e = (_d = options.pagination) === null || _d === void 0 ? void 0 : _d.defaultPage) !== null && _e !== void 0 ? _e : 1,
        filteringText: (_g = (_f = options.filtering) === null || _f === void 0 ? void 0 : _f.defaultFilteringText) !== null && _g !== void 0 ? _g : '',
        propertyFilteringQuery: (_j = (_h = options.propertyFiltering) === null || _h === void 0 ? void 0 : _h.defaultQuery) !== null && _j !== void 0 ? _j : { tokens: [], operation: 'and' },
    }), state = _k[0], dispatch = _k[1];
    return [
        state,
        createActions({
            dispatch: dispatch,
            collectionRef: collectionRef,
        }),
    ];
}
